import React from 'react';
import {
  type FormData,
  VALUES_ASSESSMENT_GROUPS,
  DEVELOPMENT_PLAN_ROWS,
  isOptionMatch,
  isValueStandardSelected,
} from './fieldMapping';
import './interview-form.css';

interface InterviewFormBackProps {
  data: FormData;
  /** 原始字段，用于价值观多选匹配 */
  rawFields?: Record<string, unknown>;
}

function EvalMark({ show }: { show: boolean }) {
  return <span className="eval-mark">{show ? '√' : ''}</span>;
}

function Checkbox({ label, checked }: { label: string; checked: boolean }) {
  return (
    <span className="checkbox-group">
      <span className={`checkbox-box${checked ? ' checked' : ''}`} />
      {label}
    </span>
  );
}

export default function InterviewFormBack({ data, rawFields = {} }: InterviewFormBackProps) {
  const d = data;

  return (
    <div className="interview-form interview-form-back form-page-break">
      <div className="form-header">
        <div className="form-logo">
          <div>
            <div className="form-company-name">壹鹿有你国际物流</div>
            <div className="form-company-en">YILUYOUNIGUOJIWULIU</div>
          </div>
        </div>
      </div>

      <div className="form-title form-title-back"></div>

      <div className="values-instruction">
        欢迎您来到壹鹿有你！感谢您抽出宝贵的时间来填写这份面试登记表及价值观评估表。请仔细阅读以下内容，结合您的实际情况进行自评，在&ldquo;自评&rdquo;栏打&ldquo;√&rdquo;（表示符合）或&ldquo;×&rdquo;（表示不符合）。最终结果仅作为面试评估参考。谢谢您的参与配合！
      </div>

      {/* ===== 价值观评估表 ===== */}
      <table className="form-table values-table">
        <thead>
          <tr>
            <th className="values-col-value">价值观</th>
            <th className="values-col-standard">行为准则</th>
            <th className="values-col-eval">自评</th>
            <th className="values-col-eval">HR评</th>
            <th className="values-col-eval">用人部门</th>
            <th className="values-col-eval">总经理</th>
          </tr>
        </thead>
        <tbody>
          {VALUES_ASSESSMENT_GROUPS.map((group) => (
            group.standards.map((standard, index) => (
              <tr key={`${group.value}-${index}`}>
                {index === 0 && (
                  <td className="values-value-cell" rowSpan={group.standards.length}>
                    {group.value}
                  </td>
                )}
                <td className="values-standard-cell">{standard}</td>
                <td className="values-eval-cell">
                  <EvalMark
                    show={isValueStandardSelected(rawFields, group.fieldName, standard)}
                  />
                </td>
                <td className="values-eval-cell" />
                <td className="values-eval-cell" />
                <td className="values-eval-cell" />
              </tr>
            ))
          ))}
        </tbody>
      </table>

      <div className="back-bottom-section">
      {/* ===== 个人能力/特质 ===== */}
      <table className="form-table">
        <tbody>
          <tr>
            <td className="section-title" colSpan={2} style={{ textAlign: 'left' }}>
              个人能力/特质
            </td>
          </tr>
          <tr>
            <td className="label-cell back-label-wide">最能描述您性格的三个形容词</td>
            <td className="value-cell">{d.personalityAdjectives}</td>
          </tr>
          <tr>
            <td className="label-cell back-label-wide">您的兴趣及特长(至少三点)</td>
            <td className="value-cell">{d.interests}</td>
          </tr>
        </tbody>
      </table>

      {/* ===== 未来发展规划 ===== */}
      <table className="form-table sub-table">
        <thead>
          <tr>
            <th colSpan={3} className="section-title" style={{ textAlign: 'left' }}>
              请描述您未来的发展规划
            </th>
          </tr>
          <tr>
            <th className="plan-period-col" />
            <th>生活目标</th>
            <th>事业目标</th>
          </tr>
        </thead>
        <tbody>
          {DEVELOPMENT_PLAN_ROWS.map((row) => (
            <tr key={row.key} className="data-row">
              <td className="plan-period-col">{row.label}</td>
              <td>{d[`plan_${row.key}_life`]}</td>
              <td>{d[`plan_${row.key}_career`]}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ===== 面试评价 ===== */}
      <table className="form-table back-eval-table">
        <tbody>
          <tr>
            <td className="back-eval-header">面试评价</td>
          </tr>
          <tr>
            <td className="back-eval-block">
              <div className="back-eval-label">初试人员评价：</div>
              <div className="back-eval-content">{d.firstInterviewComment}</div>
              <div className="back-eval-footer">
                <span className="back-eval-sign">签名：{d.firstInterviewSign}</span>
                <span className="back-eval-date">日期：{d.firstInterviewDate}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td className="back-eval-block">
              <div className="back-eval-label">复试人员评价：</div>
              <div className="back-eval-content">{d.secondInterviewComment}</div>
              <div className="back-eval-footer">
                <span className="back-eval-sign">签名：{d.secondInterviewSign}</span>
                <span className="back-eval-date">日期：{d.secondInterviewDate}</span>
              </div>
            </td>
          </tr>
          <tr>
            <td className="back-hiring-row">
              <span className="back-hiring-label">录用意见</span>
              <span className="back-hiring-options">
                <Checkbox label="予以录用" checked={isOptionMatch(d.hiringOpinion, '予以录用')} />
                <Checkbox label="有待进一步考虑" checked={isOptionMatch(d.hiringOpinion, '有待进一步考虑')} />
                <Checkbox label="不予考虑" checked={isOptionMatch(d.hiringOpinion, '不予考虑')} />
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>
  );
}
